import { render, staticRenderFns } from "./CreateForumPost.vue?vue&type=template&id=6fa73a43&"
import script from "./CreateForumPost.vue?vue&type=script&lang=js&"
export * from "./CreateForumPost.vue?vue&type=script&lang=js&"
import style0 from "./CreateForumPost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports